import { render } from "./ManageServiceSlots.vue?vue&type=template&id=dba51f5a&scoped=true"
import script from "./ManageServiceSlots.vue?vue&type=script&lang=js"
export * from "./ManageServiceSlots.vue?vue&type=script&lang=js"

import "./ManageServiceSlots.vue?vue&type=style&index=0&id=dba51f5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dba51f5a"]])

export default __exports__